module.exports = __webpack_public_path__ + "img/working_variations.cfe15861.jpg";